// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"fb13af2a","300":"c7b147f7","592":"63697480","952":"7a41ee71"}[chunkId] + ".chunk.js";
};